import { Component, Input} from '@angular/core';
import { SIDENAV_DATA_MODULES } from '../../../lib/constants/proj.cnst';


@Component({
  selector: 'lib-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
 
})
export class SidenavContentComponent {

  @Input() selectedOption:string = 'default';

  sideNavOptions = SIDENAV_DATA_MODULES;
  fadeInOutState: 'fadeIn' | 'fadeOut' = 'fadeIn';

  constructor() {}



}
